<app-accordion title="About Us" i18n-title [maxWidth]="maxWidth">
  At Allergan Aesthetics we believe in the remarkable impact confidence can
  have on the lives, businesses, and careers of those we serve through our
  history of a company built on patient-care, education and support of our
  customers, and our commitment to putting the patients we serve first.
</app-accordion>
